<template>
	<div class="batch-btn-wrap">
		<div class="main">
			<van-dropdown-menu direction="up" class="batch-group" v-if="options.length > 0">
			  <van-dropdown-item v-for="(option, i) in options" :title="option.text">
					<van-cell v-for="(child,ci) in option.children" @click="command(child.value, option.params)">
							{{ child.text }}
					</van-cell>
				</van-dropdown-item>
			</van-dropdown-menu>
			<van-cell class="batch-cancel" @click="command('cancel')">取消</van-cell>
		</div>
	</div>
</template>

<script>
export default {
  components: {},
  props: {
		options: {
			type: [Array],
			default: () => {
				return [];
			}
		},
	},
  data() {
    return {};
  },
  watch: {},

  methods: {
    init() {},
		command(sign, params) {
			params = params ? params : {};
			this.$emit('command', sign, params);
		},
  },
  created() {
    this.init();
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
	.batch-btn-wrap {
		position: fixed;
		width: 100%;
		bottom: 0px;
		.main {
			display: flex;
			justify-content: flex-end;
		}
		
		.batch-cancel {
			flex: 1;
			box-shadow: 0 2px 12px rgba(100,101,102,.12);
			border-left: 1px solid rgb(235,235,235);
			.van-cell__value {
				text-align: center;
				color: #f16868;
			}
		}
		.batch-group {
			flex: 1;
		}
	}
	
	
</style>